import { v4 as uuidv4 } from 'uuid'

export const services = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: 'Service Code ' + ++index,
  __typename: 'Service'
}))
